import UnderConstruction from "@/components/feature/UnderConstruction";

export default function Legal() {
  return <UnderConstruction title="特定商取引法に基づく表記" />;
}